<button class="btn btn-link" [attr.data-cy]="cySelector">
    <i class="fas fa-filter me-1"></i>Filter
</button>
